<template>
    <div>
        <transition name="transitionName">
            <iframe :id="video.id" class="mb-2 modal-video" :src="video.url" frameborder="0"></iframe>
        </transition>
        <div class="d-none d-sm-flex justify-content-around">
            <w-button class="w-25" @click="change(-1)">Previous Video</w-button>
            <w-button class="w-25" @click="viewAll">View All</w-button>
            <w-button class="w-25" @click="change(1)">Next Video</w-button>
        </div>
    </div>
</template>

<script>
import videos from '@/assets/json/videos.json'

export default {
    name: 'HelpVideo',
    props: ['id'],
    data () {
        return {
            transitionName: 'slide-left'
        }
    },
    methods: {
        change (direction) {
            let id = this.id
            let index = videos.findIndex(item => item.id === parseFloat(this.id))
            if (direction === 1) {
                if (index === videos.length - 1 || index === -1) id = 1
                else id = parseInt(this.id) + 1
            } else {
                if (index === 0 || index === -1) id = videos[videos.length - 1].id
                else id = this.id - 1
            }

            this.$emit('change', id)
        },
        viewAll () {
            this.$emit('viewAll')
        }
    },
    computed: {
        video () {
            return videos.find(item => parseInt(item.id) === parseInt(this.id))
        }
    }
}
</script>

<style scoped>
    iframe {
        width: 80%;
        height: 475px;
    }

    @media (max-width: 768px) {
        .modal-video {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            margin: 0 !important;
        }

        .navigation {
            display: none;
        }
    }

    .slide-left-leave-active,
    .slide-left-enter-active {
        transition: 1s;
    }

    .slide-left-enter {
        transform: translate(100%, 0);
    }

    .slide-left-leave-to {
        transform: translate(-100%, 0);
    }
</style>
